/* eslint-disable jsx-a11y/anchor-is-valid */
import '../../../../../../../../App.css'
import {toAbsoluteUrl} from '../../../../../../../../_ePulse/helpers'

export function Template4(props: any) {
  const {headerHeight, footerHeight} = props
  return (
    <div
      style={{
        width: '750px',
        margin: '0 auto',
        fontSize: '14px',
        fontFamily: "'Montserrat', sans-serif",
      }}
    >
      <div
        style={{
          border: '1px solid #c3c0c0',
          textAlign: 'center',
          margin: '0',
          width: '100%',
          height: headerHeight + 'px',
          position: 'relative',
        }}
      ></div>

      <div className='template-body mt-5'>
        <div className='patient-details'>
          <div className='patient-details-box'>
            <div>
              <span className='label'>Patient Name: </span> [Patient Name]
            </div>
            <div>
              <span className='label'>Patient Phone No: </span> [0102030405]
            </div>
            <div>
              <span className='label'>Gender / Age : </span> Male / 25y 2m
            </div>
          </div>
          <div className='patient-details-box'>
            <div>
              <span className='label'>Consultatlon Date: </span> 26/10/2023
            </div>
            <div>
              <span className='label'>Consultatlon Type: </span> Clinic Appointment
            </div>
          </div>
        </div>
        <div className='seperator-line'></div>
        <div className='magin-20'>
          <div className='category'>Vitals</div>
          <div className='margin-10'>
            <div className='sub-category'>Basic Vitals</div>
            <div className='text-font-family data-font-size'>CVS: 1234</div>
            <div className='text-font-family data-font-size'>Blood Pressure: 120/80 mmHg</div>
          </div>
          <div className='margin-10'>
            <div className='sub-category'>Selective Vitals</div>
            <div className='text-font-family data-font-size'>CVS: 1234</div>
            <div className='text-font-family data-font-size'>Blood Pressure: 120/80 mmHg</div>
          </div>
        </div>
        <div className='magin-20'>
          <div className='category'>Complaints</div>
          <div className='text-font-family data-font-size'>
            Itchy palms, cardiomegaly, strawberry cervix, eyeball is swollen, itchy eye, clogged
            pores in bald spots, sternal lift
          </div>
        </div>
        <div className='magin-20'>
          <div className='category'>Diagnosis</div>
          <div className='text-font-family data-font-size'>Obesity, Hypertension</div>
        </div>
        <div className='magin-20'>
          <div className='category'>Rx</div>
          <table
            className='w-100'
            // cellpadding="0" cellspacing="0"
          >
            <tr className='label'>
              <td className='table-head'></td>
              <td className='table-head'>Medicine</td>
              <td className='table-head'>Dose</td>
              <td className='table-head'>Timing</td>
              <td className='table-head'>Duration</td>
            </tr>
            <tr>
              <td className='table-data'>
                <span className='label'>Dolo 50mg</span> <br />
                <span className='label-2'>(Paracetamol)</span>
              </td>
              <td className='table-data'>0-0-1</td>
              <td className='table-data'>After meal</td>
              <td className='table-data'>5 days</td>
            </tr>
            <tr>
              <td className='table-data'>
                <span className='label'>Omnacortil 10 MG Tablet</span> <br />
                <span className='label-2'>(Prednisolone)</span>
              </td>
              <td className='table-data'>1-0-1</td>
              <td className='table-data'>After meal</td>
              <td className='table-data'>7 days</td>
            </tr>
            <tr>
              <td className='table-data'>
                <span className='label'>Advil 10 MG Drops</span> <br />
                <span className='label-2'>(Ibuprofen)</span>
              </td>
              <td className='table-data'>1-1-1</td>
              <td className='table-data'>before meal</td>
              <td className='table-data'>10 days</td>
            </tr>
          </table>
        </div>
        <div className='magin-20'>
          <div className='category'>Test Required</div>
          <div className='text-font-family data-font-size'>ECG, FBS</div>
        </div>
        <div className='magin-20'>
          <div className='category'>Advice</div>
          <div className='text-font-family data-font-size'>
            Drink more water, Exercise Regularly
          </div>
        </div>
      </div>

      <div
        style={{marginTop: '50px', textAlign: 'right', display: 'flex', flexDirection: 'column'}}
      >
        <div
          style={{
            backgroundColor: '#dddddd',
            height: '1px',
            width: '200px',
            marginLeft: 'auto',
            marginBottom: '5px',
          }}
        ></div>
        <div
          className='text-font-family data-font-size'
          style={{fontWeight: 600, marginBottom: '4px'}}
        >
          Signed
        </div>
      </div>

      <div
        style={{
          height: footerHeight + 'px',
          width: '100%',
          border: '1px solid #c3c0c0',
          padding: '0',
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
        }}
      >
        {/* <div
          style={{
            background: 'linear-gradient(270deg, #29aaa9 0.09%, #564ea1 99.92%)',
            padding: '10px 80px 10px 10px',
            borderRadius: '0 100px 0 0',
          }}
        >
          <span className='text-font-family data-font-size text-white'>
            <img
              src='/media/ePulse/phone_logo.svg'
              style={{maxHeight: '16px', marginRight: '3px', position: 'relative', top: '0px'}}
              alt='Phone Icon'
            />
            +91-1020304050
          </span>
          <br />
          <span className='text-font-family data-font-size text-white'>
            <img
              src='/media/ePulse/email_logo.svg'
              style={{maxHeight: '16px', marginRight: '3px', position: 'relative', top: '0px'}}
              alt='Email Icon'
            />
            vijay.sharma@getwell.com
          </span>
          <br />
          <span className='text-font-family data-font-size text-white'>
            <img
              src='/media/ePulse/website_icon.svg'
              style={{maxHeight: '16px', marginRight: '3px', position: 'relative', top: '0px'}}
              alt='website Icon'
            />
            myepulse.in
          </span>
        </div>
        <div
          style={{
            background: 'linear-gradient(270deg, #29aaa9 0.09%, #564ea1 99.92%)',
            padding: '10px 10px 10px 80px',
            borderRadius: '100px 0 0 0',
            minHeight: '83px',
          }}
        >
          <span className='text-font-family data-font-size text-white'>
            Dr. Vijay Sankar Sharma
          </span>
          <br />
          <span className='text-font-family data-font-size text-white'>C-Scheme, Jaipur</span>
        </div> */}
      </div>
    </div>
  )
}
